import { render, staticRenderFns } from "./postRecord.vue?vue&type=template&id=79a2fe94&scoped=true&"
import script from "./postRecord.vue?vue&type=script&lang=js&"
export * from "./postRecord.vue?vue&type=script&lang=js&"
import style0 from "./postRecord.vue?vue&type=style&index=0&id=79a2fe94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a2fe94",
  null
  
)

export default component.exports